import { useTranslation } from 'react-i18next'

import { CardCompradorContent, CardCompradorInfo } from '@/features/proposta/components/card-comprador'
import type { TProcurador } from '@/features/proposta/interfaces/compradores.types'

interface IListaProcuradoresProps {
  procuradores?: TProcurador[]
  onEdit: (cliente: TProcurador) => void
}

export const ListaProcuradores = ({ procuradores, onEdit }: IListaProcuradoresProps) => {
  const { t } = useTranslation('proposta')
  if (!procuradores?.length) return null
  return procuradores.map((procurador) => (
    <CardCompradorContent
      key={procurador.id}
      onEdit={() => {
        onEdit?.(procurador)
      }}
      className="border-t border-b-0"
    >
      <CardCompradorInfo tipo={t('cadastro_compradores.tipo.procurador')} nome={procurador.nome} exibirAvatar={false} />
    </CardCompradorContent>
  ))
}
